// extracted by mini-css-extract-plugin
export default {"form-item":"loginForm_form-item__wgrmL","form-input-block":"loginForm_form-input-block__9MkEB","login-form_google-recaptcha":"loginForm_login-form_google-recaptcha__PX4rV"};